import styled from 'styled-components';
import { Media } from '../../../theme/Media';
// #region Card
export const CardWrapper = styled.div `
  ${({ theme }) => theme.shadows.small}
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.grey00_1};
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  ${({ height }) => height && `height: ${height};`};
`;
// #endregion
// #region CardTitle
export const CardTitleWrapper = styled.div `
  display: flex;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.grey10_1}`};
`;
export const ActionsWrapper = styled.div `
  display: flex;
  gap: 8px;
`;
export const ContentWrapper = styled.div `
  flex: 1 1 auto;
  display: flex;
  padding: 21px 24px;
  gap: 16px;

  @media ${Media.xsMax} {
    padding: 9px 12px;
  }
`;
export const TitleWrapper = styled.div `
  flex: 0 0 auto;
  padding: 3px 0;
  display: flex;
  align-items: center;
  gap: 4px;
  ${({ theme }) => theme.typography.title};
  color: ${({ theme }) => theme.colors.black_1};
`;
export const FilterWrapper = styled.div `
  flex: 1 1 auto;
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: flex-start;
`;
export const ActionWrapper = styled.div `
  flex: 1 1 auto;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
`;
export const ToggleStartWrapper = styled.div `
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-right: 1px solid ${({ theme }) => theme.colors.grey10_1};
`;
export const ToggleEndWrapper = styled.div `
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-left: 1px solid ${({ theme }) => theme.colors.grey10_1};
`;
// #endregion
// #region CardSection
const CardContentBase = styled.div `
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
`;
// this fixes the issue with & + & selector when swithing themes
export const CardContent = styled(CardContentBase) `
  & + ${CardContentBase} {
    border-top: 1px solid ${({ theme }) => theme.colors.grey05_4};
  }
`;
export const CardSectionTitle = styled.div `
  ${({ theme }) => theme.typography.titleSub};
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  margin: 0;
  cursor: ${({ onClick }) => !!onClick && 'pointer'};

  & span {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  @media ${Media.xsMax} {
    padding: 16px 12px;
  }
`;
export const CardSectionSubTitle = styled.div `
  padding: 4px 24px;

  @media ${Media.xsMax} {
    padding: 4px 16px;
  }
`;
export const CardSectionContentWrapper = styled.div `
  padding: ${({ noPadding, withoutTitle }) => (noPadding ? 0 : withoutTitle ? '24px' : '0 24px 24px')};
  position: relative;

  @media ${Media.xsMax} {
    padding: ${({ noPadding, withoutTitle }) => (noPadding ? 0 : withoutTitle ? '16px 12px' : '0 12px 16px')};
  }
`;
export const CardSectionContent = styled.div `
  flex: 1 1 auto;
`;
// #endregion
